import { Container, Card, Table, Col, Row, Button, Modal, Form, Spinner, Badge, Dropdown} from "react-bootstrap";
import Layout from "../components/Layout";
import { useDispatch, useSelector } from "react-redux";
import arc1 from '../assets/images/arc1.svg';
import arc2 from '../assets/images/arc2.svg';
import { useEffect, useRef, useState } from "react";
import { addPettyBeneficiary, creditPettyWallet, downloadPettyCashLog, getBankList, getOTP, getPettyBeneficaries, getPettyWallet, getPettyWalletLog, payPettyBeneficiary, requestNewOTP } from "../redux/slices/account.service";
import dateFormatter from "../utils/dateFormatter";
import formatCurrency from "../utils/currencyFormmter";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RecordFilter from "../components/RecordFilter";
import Paginator from "../components/table/Paginator";
import Select from "react-select";
import Swal from "sweetalert2";
import AccountService from "../services/account.service";
import AmountInput from "../components/AmountInput";
import Logo from "../components/Logo";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toPng } from "html-to-image";
import { managerAddPettyBeneficiary, managerGetPettyBeneficaries, managerGetPettyWallet, managerGetPettyWalletLog, managerPayPettyBeneficiary, managerSubmitPettyRequest } from "../redux/slices/manager.auth.slice";

const PettyCash = () => {

    const dispatch = useDispatch()
    const isLoaded = useRef(false)
    const receiptRef = useRef();
    const navigate = useNavigate()

    const stopPropagation = (e) => e.stopPropagation();
    const { user = {} } = useSelector((state) => state.auth)

    const [state, setState] = useState({
        analytics: {},
        results: [],
        showBeneficiaryForm: false,
        showFundingForm: false,
        showPaymentForm: false,
        loading: false,
        paginationData: {},
        page: 1,
        wallet: {},
        payload: {
            status: '',
            type: '',
            reference: '',
            date: '',
            otp: '',
        },
        errors: {},
        banks: [],
        beneficiaries: [],
        beneficiary: {},
        receipt: {},
        showReceipt: false,
        copiedText: '',
        showRequestForm: false,
        attachment_file:  null,
        attachment_image: null,
    })

    useEffect(() => {
        if(!isLoaded.current) {
            loadPettyCashLogs()
            getWallet()
            getBanks()
            isLoaded.current =  true
        }
    }, [state.payload.page])

    const loadPettyCashLogs = () => {
        let queryParams = state.payload
        queryParams.user_type = user?.user_type
        
        setState((prevState) => ({...prevState, loading: true}))
        const action = user?.user_type === 'owner' ? getPettyWalletLog(queryParams) : managerGetPettyWalletLog(queryParams)
        dispatch(action)
        .then((response) => {
            let result = []
            let analytics = {}

            if(response.payload?.results) {
                result = response.payload.results
            }
            if(response.payload?.analytics) {
                analytics = response.payload.analytics
            }
            setState((prevState) => ({...prevState, results: result, analytics: analytics}))
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const getWallet = () => {
        const action = user?.user_type === 'owner' ? getPettyWallet() : managerGetPettyWallet();
        dispatch(action)
        .then((response) => {
            if (response?.payload?.success === true) {
                setState((prevState) => ({ ...prevState, wallet: response.payload.data }));
            } else {
                console.error('Failed to fetch wallet:', response?.payload?.message || 'Unknown error');
            }
        })
        .catch((error) => {
            console.error('Error fetching wallet:', error);
        })
    }

    const handleInput = (event) => {
        const { name, value } = event.target;
        
        setState(prevState => ({
            ...prevState,
            payload: {
                ...prevState.payload,
                ...(name === 'filter_by' ? 
                    value === 'all' ? {
                        from_date: '',
                        to_date: '',
                        download: false,
                        filter: '',
                        filter_by: ''
                    } : 
                    value === 'type_date' ? {
                        filter_by: 'transaction_type',
                        download: false,
                    } :
                    value === 'type' ? {
                        from_date: '',
                        to_date: '',
                        filter_by: 'transaction_type',
                        download: false,
                    } : {
                        [name]: value
                    }
                    : { [name]: value }
                )
            }
        }));
    };

    const handleValidation = (event) => {

        const regex = /^\d*\.?\d*$/;
        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
    
        const {name, value} = event.target
        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }

        else if (name ==='amount' && !regex.test(parseFloat(value.replace(/[^\d.]/g, '')))) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }
        else {
            event.target.style = "border-style: transparent"
            delete state.errors[name]
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }
    }

    const handlePagination = (data) => {
        setState((prevState) => ({...prevState, page: data}))
    }

    const handleBankSelect = (event) => {
        setState((prevState) => ({...prevState, payload: {...prevState.payload, code:event.value}}))
        setState((prevState) => ({...prevState, payload: {...prevState.payload, bank:event.label}}))
    }

    const getBanks = () => {
        // if(user?.user_type != 'owner') {
        //     return;
        // }
        dispatch(getBankList())
        .then((e) => {
            if(typeof(e.payload) === 'object' && e.payload?.success !== false  && !e.payload?.detail) {
                const options =  e.payload?.map(bank =>  { 
                    return {value: bank.code, label: bank.name} 
                })
                setState((prevState) => ({...prevState, "banks": options}))
            }
        } )
    }

    const handlePaymentFormToggle = () => {
        getBeneficiaries()
        setState((prevState) => ({...prevState, showPaymentForm: !state.showPaymentForm}))
    }

    const handleBeneficiarySelect = (event) => {
        setState((prevState) => ({
            ...prevState, 
            payload: {...prevState.payload, beneficiary:event.label, beneficiary_id: event.value},
            beneficiary: event,
        }))
    }

    const getBeneficiaries = () => {
       const action = user?.user_type === 'owner' ? getPettyBeneficaries() : managerGetPettyBeneficaries()
        dispatch(action)
        .then((response) => {
            if(response.payload?.results) {
                const options =  response.payload?.results.map(beneficiary =>  { 
                    return {value: beneficiary.id, label: `${beneficiary.account_name} - ${beneficiary.bank_name}`} 
                })
                setState((prevState) => ({...prevState, "beneficiaries": options}))
            }
        } )
    }

    const confirmAction = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "This will add the beneficiary to your account",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed!'
        }).then((result) => {
            if (result.isConfirmed) {
                addBeneficiary()
            }
        })
    }

    const addBeneficiary = () => {
        if(state.payload.bank === '' || state.payload.bank === undefined) {
            Swal.fire({
                icon: 'error',
                text: 'Select a bank',
            })
            return
        }
        else if(state.payload.bank_verified === false || state.payload.bank_verified === undefined) {
            Swal.fire({
                icon: 'error',
                text: 'Verify bank account',
            })
            return
        }
        else if(state.payload.pin === '' || state.payload.pin === undefined) {
            Swal.fire({
                icon: 'error',
                text: 'Enter your PIN',
            })
            return
        }
        else if(state.payload.otp === '' || state.payload.otp === undefined) {
            Swal.fire({
                icon: 'error',
                text: 'Enter the OTP sent to your email',
            })
            return
        }

        const requestPayload = { 
            bank: state.payload.bank,  
            bank_verified: state.payload.bank_verified, 
            code: state.payload.code,
            account_number: state.payload.account_number,
            account_name: state.payload.account_name,
            business_name: state.payload.business_name,
            pin: state.payload.pin,
            otp: state.payload.otp,
        }
        
        setState((prevState) => ({...prevState, loading: true }))
        const action = user?.user_type === 'owner' ? addPettyBeneficiary(requestPayload) : managerAddPettyBeneficiary(requestPayload)
        dispatch(action)
        .then((response) => {
            if(response?.payload?.success === true) {
                setState((prevState) => ({...prevState, showBeneficiaryForm: false}))
                Swal.fire({
                    icon: 'success',
                    text: response.payload.message,
                })
            }
            else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response.payload.message || 'An error occured',
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false })))

    }

    const verifyAccountNumber = async (event) => {
        const { value } = event.target
        if(value.length < 10 || (state.payload.code === '' || state.payload.code === undefined)) return;
        try {
            const response = await AccountService.validateAccountNumber({code: state.payload.code, account_number: value})
            if(response.data) {
                setState((prevState) => ({
                    ...prevState, 
                    payload: {...prevState.payload, bank_verified: true, account_name: response.data.account_name, account_number:value}
                }))
                Swal.fire({
                    icon: 'success',
                    text: 'Account verification successful. '+response.data.account_name
                })
            }
        } catch (error) {
            const message = error?.message
            Swal.fire({
                icon: 'error',
                text: message,
            })
        }
        finally {
            setState((prevState) => ({...prevState, loading: false }))
        }
        
    }

    const handleAmountUpdate = (data) => {
        const cleanAmount = data.split(',').join('')
        setState((prevState) => ({...prevState, payload: {...prevState.payload, amount: cleanAmount}}))
    }

    const fundWallet = () => {
        const requestPayload = { 
            amount: state.payload.amount,
            pin: state.payload.pin,
            otp: state.payload.otp,
        }

        if(state.payloadamount === '' || state.payload.amount === undefined) {
            setState((prevState) => ({...prevState, errors: {...prevState.errors, amount: 'Amount is required'}}))
            return
        }
        else {
            delete state.errors['amount']
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }

        Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text: "This will add the amount to your wallet",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed!'
        })
        .then((result) => {
            if (result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true }))
                dispatch(creditPettyWallet(requestPayload))
                .then((response) => {
                    if(response?.payload?.success === true) {
                        setState((prevState) => ({...prevState, showFundingForm: false}))
                        Swal.fire({
                            icon: 'success',
                            text: response.payload.message,
                        })
                        getWallet()
                        loadPettyCashLogs()
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: response.payload.message,
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false })))
            }
        })
        

    }

    const submitPettyCashRequest = () => {

        if(state.payloadamount === '' || state.payload.amount === undefined) {
            setState((prevState) => ({...prevState, errors: {...prevState.errors, amount: 'Amount is required'}}))
            return
        }
        else {
            delete state.errors['amount']
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }

        let formdata = new FormData()
        formdata.append('amount', state.payload.amount)
        formdata.append('reason', state.payload.reason)
        formdata.append('attachment', state.attachment_file)

        Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text: `This will submit a request of ${formatCurrency(state.payload.amount).with_currency}`,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed!'
        })
        .then((result) => {
            if (result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true }))
                dispatch(managerSubmitPettyRequest(formdata))
                .then((response) => {
                    if(response?.payload?.success === true) {
                        setState((prevState) => ({...prevState, showRequestForm: false, attachment_image: '', attachment_file: null}))
                        Swal.fire({
                            icon: 'success',
                            text: response.payload.message,
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: response.payload.message,
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false })))
            }
        })
    }

    const payBeneficiary = () => {

        if(state.payload.amount === '' || state.payload.amount === undefined) {
            setState((prevState) => ({...prevState, errors: {...prevState.errors, amount: 'Amount is required'}}))
            return
        }
        else {
            delete state.errors['amount']
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }

        if(state.payload.beneficiary_id === '' || state.payload.beneficiary_id === undefined) {
            setState((prevState) => ({...prevState, errors: {...prevState.errors, beneficiary: 'Select a beneficiary'}}))
            return
        }
        else {
            delete state.errors['beneficiary']
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }

        let formdata = new FormData()
        formdata.append('pin', state.payload.pin)
        formdata.append('amount', state.payload.amount)
        formdata.append('beneficiary_id', state.payload.beneficiary_id)
        formdata.append('payment_reason', state.payload.payment_reason)
        formdata.append('otp', state.payload.otp)
        
        if(state.attachment_file != null && state.attachment_file != undefined) {
            formdata.append('attachment', state.attachment_file)
        }

        Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text:  `You wallet will be debited with ${formatCurrency(state.payload.amount).with_currency}`,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed!'
        })
        .then((result) => {
            if (result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true }))
                const action =  user?.user_type === 'owner' ? payPettyBeneficiary(formdata) : managerPayPettyBeneficiary(formdata)
                dispatch(action)
                .then((response) => {
                    if(response?.payload?.success === true) {
                        setState((prevState) => ({...prevState, showPaymentForm: false}))
                        Swal.fire({
                            icon: 'success',
                            text: response.payload.message,
                        })
                        getWallet()
                        loadPettyCashLogs()
                    }
                    else {
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            text: response.payload.message || 'An error occured',
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false })))
            }
        })
    }

    const selectTransaction = (item) => {
        setState((prevState) => ({...prevState, receipt: item, showReceipt: true}));
    }

    const generatePdf = () => {
        const input = document.getElementById('pdf-content');
        
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            
            // Calculate the width and height to fit the PDF
            const imgWidth = 190; // A4 width in mm
            const pageHeight = pdf.internal.pageSize.height;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;

            let position = 0;

            // Add the image to the PDF
            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            
            // Save the PDF
            pdf.save(`receipt.pdf`);
        });
    }

    const handleShare = async () => {
        try {
            const dataUrl = await toPng(receiptRef.current);
            const blob = await (await fetch(dataUrl)).blob();
        
            const file = new File([blob], 'receipt.png', { type: 'image/png' });
        
            await navigator.share({
                files: [file],
                title: 'Receipt',
                text: 'Here is your receipt',
            });
            // alert('Receipt shared successfully!');
        } catch (error) {
            console.error('Error sharing receipt:', error);
            // alert('Failed to share receipt.');
        }
    }

    const handleReportDownload = () => {
        let queryParams = state.payload
        queryParams.download = true
        const action = user?.user_type === 'owner' ? getPettyWalletLog(queryParams) : managerGetPettyWalletLog(queryParams)
        dispatch(action)
    }

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            setState((prevState) => ({...prevState,  attachment_file: file, attachment_image: reader.result}))
        };
    }

    const requestOTP = () => {
        Swal.fire({
            icon: 'info',
            text: 'An OTP will be sent to your email. Do you wish to proceed?',
            confirmButtonText: 'Yes, Proceed',
            cancelButtonText: 'No, Abort',
            showCancelButton: true,
            showConfirmButton: true
        })
        .then((result) => {
            if(result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true}))
                dispatch(requestNewOTP()) 
                .then((response) => {
                    if(response?.payload?.success === true) {
                        Swal.fire({
                            icon: 'success',
                            text: response?.payload?.message || 'OTP sent successfully.'
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: response?.payload?.message || 'Could not send OTP.'
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false})))
            }
        })
    }

    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <Col md={12} className="row align-items-center justify-content-between flex-wrapd">
                    <div className="col-md-4">
                        <h3 className="m-0">PettyCash</h3>
                        <p>
                            <small>Manage pettycash details</small>
                        </p>                        
                    </div>
                    <div className="col-md-8 text-right">
                        <Button 
                            type="button" 
                            className="border-0 mb-2 px-3"
                            onClick={ () => setState((prevState) => ({...prevState, showBeneficiaryForm: !state.showBeneficiaryForm}))}
                        >
                            <FontAwesomeIcon icon={'plus'}/>
                            <span className="ps-2">Add Beneficiary</span>
                        </Button>
                        {
                            user?.user_type === 'owner' &&
                            <>
                                <Button 
                                    type="button" 
                                    variant="primary" 
                                    className="border-0 mb-2 ms-2"
                                    onClick={ () => setState((prevState) => ({...prevState, showFundingForm: !state.showFundingForm}))}
                                >
                                    <FontAwesomeIcon icon={'wallet'} />
                                    <span className="ps-2">Fund Wallet</span>
                                </Button>
                            </>
                        }
                        {
                            user?.user_type !== 'owner' &&
                            <Button 
                                type="button" 
                                variant="primary" 
                                className="border-0 mb-2 ms-2"
                                onClick={ () => setState((prevState) => ({...prevState, showRequestForm: !state.showRequestForm}))}
                            >
                                <FontAwesomeIcon icon={'sack-dollar'} />
                                <span className="ps-2">Request Cash</span>
                            </Button>
                        }
                        <Button 
                            type="button" 
                            variant="primary" 
                            className="border-0 mb-2 ms-2"
                            onClick={ handlePaymentFormToggle}
                        >
                            <FontAwesomeIcon icon={'users'} />
                            <span className="ps-2">Pay Beneficiary</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            className="border-0 mb-2 ms-2"
                            onClick={ () => user.user_type === 'owner' ? navigate('/petty-cash-requests') : navigate('/members/petty-cash-requests')}
                        >
                            <FontAwesomeIcon icon={'list'} />
                            <span className="ps-2">Requests</span>
                        </Button>
                    </div>
                </Col>
                <Row>
                    <Col lg={4} md={4} className="mb-3">
                        <div className="data-card rounded-16 bg-white p-4">
                            <p className="font-bold text-dark">Balance</p>
                            <h3 className="text-secondary font-bold">{formatCurrency(state.wallet?.balance || state.wallet?.amount).with_currency}</h3>
                            <div className="elipse">
                                <img src={arc1} alt="arc" />
                            </div>
                            <div className="elipse">
                                <img src={arc2} alt="arc" />
                            </div>
                        </div>
                    </Col>
                    <Col md="12 mt-4">
                        <RecordFilter
                            handleInput={handleInput}
                            handleSearchSubmit={() => loadPettyCashLogs()}
                            params={[
                                {label: 'All', value: 'all'},
                                {label: 'Type', value: 'type'},
                                {label: 'Date', value: 'date'},
                                {label: 'Type & Date', value: 'type_date'},
                            ]}
                        />
                        <Card className="shaow-sm border-0">
                            <Card.Header className="text-right bg-transparent">
                                <Button type="button" variant="primary" onClick={handleReportDownload}>
                                    <FontAwesomeIcon icon={'cloud-download'} /> Download
                                </Button>
                            </Card.Header>
                            <Card.Body className="table-responsive">
                                <Table size="sm" className="table-color">
                                    <thead>
                                        <tr>
                                            <th>Details</th>
                                            <th>Reference</th>
                                            <th>Amount</th>
                                            <th>Balance Before</th>
                                            <th>Balance After</th>
                                            <th>Fee</th>
                                            <th>Type</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            state.loading && 
                                            <tr>
                                                <td colSpan={7} className="in-page-loader">
                                                    <Spinner size="lg" variant="primary"/>
                                                </td>
                                            </tr>
                                        }
                                        {
                                            state.results?.length ? (
                                                state.results?.map((item, index) => (
                                                    <tr key={ index }>
                                                        <td className="m-0 d-flex gap-2 align-items-center" style={{maxWidth: "400px"}}>
                                                            <strong>
                                                                <p className="m-0">{item.description}</p>  
                                                                <small className="font-bold text-primary">{dateFormatter(item.date)}</small>
                                                            </strong>
                                                        </td>
                                                        <td>{ item.reference }</td>
                                                        <td>{ formatCurrency(item.amount, item.currency).with_currency }</td>
                                                        <td>{ formatCurrency(item.amount_before, item.currency).with_currency } </td>
                                                        <td>{ formatCurrency(item.amount_after, item.currency).with_currency } </td>
                                                        <td>{ formatCurrency(item.fee, item.currency).with_currency } </td>
                                                        <td className="m-0 d-flex align-items-center gap-2">
                                                            <FontAwesomeIcon icon="fa fa-money-check"/>
                                                            { item.transaction_type }
                                                        </td>
                                                        <td>
                                                           <div className="d-flex m-0 align-items-center justify-content-between">
                                                                <Badge 
                                                                    className={item.status === 'success' ? 'badge-active' : 
                                                                    (item.status === 'failed' ? 'badge-failed' : 
                                                                    (item.status === 'used' ? 'badge-used' : 'badge-pending'))}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                        <circle cx="5" cy="5" r="5" fill={
                                                                            item.status === 'success' ? "#008000" : 
                                                                            (item.status === 'failed' ? "#EB5757" : 
                                                                            (item.status === 'used' ? "#828282" : "#FAB941"))
                                                                        }
                                                                        />
                                                                    </svg>
                                                                    <span className="ps-1">
                                                                        {item.status}
                                                                    </span>
                                                                </Badge> 
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="light" className="border-0 bg-transparent" size="sm" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                    </Dropdown.Toggle>
        
                                                                    <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                        <Dropdown.Item 
                                                                            eventKey={1} 
                                                                            className="text-primary d-flex align-items-center gap-1" 
                                                                            onClick={() => selectTransaction(item)}
                                                                        >
                                                                        <i className="lni lni-eye" style={{fontSize: "20px"}}></i>  View Details
                                                                    </Dropdown.Item>
                                                                    {
                                                                        item.attachment && 
                                                                        <>
                                                                            <Dropdown.Divider />
                                                                            <Dropdown.Item 
                                                                                eventKey={2} 
                                                                                className="text-primary d-flex align-items-center gap-1" 
                                                                                href={item.attachment}
                                                                            >
                                                                                <FontAwesomeIcon icon={'paperclip'} /> View Attachment
                                                                            </Dropdown.Item>
                                                                        </>
                                                                    }
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                           </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )
                                            : 
                                            (
                                                <tr>
                                                    <td colSpan={5} className="text-center text-muted">No data found</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                        {
                            state.results?.length ? (
                                <div className="table-responsive mt-2">
                                    <Paginator
                                        next={state.paginationData.next} 
                                        prev={state.paginationData.prev}
                                        setCurrentPage={ handlePagination }
                                    />
                                </div>
                            ) : null
                        }
                    </Col>
                </Row>

                {/* Pay beneficiary */}
                <Modal 
                    show={state.showPaymentForm}
                    onHide={() => setState((prevState) => ({...prevState, showPaymentForm: !state.showPaymentForm}))}
                    backdrop="static"
                >
                    <Modal.Header closeButton className="bg-primary p-1 px-2 text-white">
                        <Modal.Title>
                            Pay Beneficiary
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Beneficiary</Form.Label>
                                    <Select 
                                        name="beneficiary" 
                                        onChange={handleBeneficiarySelect} 
                                        options={state.beneficiaries}
                                        selected={`${state.payload?.beneficiary?.account_name} - ${state.payload?.beneficiary?.bank_name}`}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                height: "40px",
                                                backgroundColor: "#f2f2f2"
                                            }),
                                        }}
                                    />
                                    {
                                        state.errors['beneficiary'] && 
                                        <Form.Text className="text-danger">{state.errors['beneficiary']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0">Amount</Form.Label>
                                    <AmountInput onChange={handleAmountUpdate} />
                                    {
                                        state.errors['amount'] && 
                                        <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} sm={12} xs={12} className="mb-3">
                                    <Form.Label className="mb-0">Payment Reason</Form.Label>
                                    <textarea
                                        required
                                        placeholder="Payment reason"
                                        name="payment_reason"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        className="form-control"
                                    ></textarea>
                                    {
                                        state.errors['payment_reason'] && 
                                        <Form.Text className="text-danger">{state.errors['payment_reason']}</Form.Text>
                                    }
                                </Form.Group>
                                
                                <Form.Group as={Col} md={12} sm={12} xs={12} className="mb-3">
                                    <Form.Label className="mb-0">PIN</Form.Label>
                                    <Form.Control
                                        type="password"
                                        required
                                        placeholder="PIN"
                                        name="pin"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        autoComplete="off"
                                    />
                                    {
                                        state.errors['pin'] && 
                                        <Form.Text className="text-danger">{state.errors['pin']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md="12" className="mb-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <Form.Label className="mb-0">
                                        <span>OTP</span>  
                                        </Form.Label>
                                        <Button 
                                            type="button" 
                                            variant="outline-primary" 
                                            size="sm" 
                                            className="mb-1 w-25" 
                                            onClick={requestOTP}
                                        >Request OTP</Button> 
                                    </div>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="OTP"
                                        name="otp"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['otp'] && 
                                        <Form.Text className="text-danger">{state.errors['otp']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} sm={12} className="mb-3">
                                    <span>Attach file</span><small>(optional)</small>
                                    <Form.Control
                                        type="file"
                                        onChange={handleFileSelect}
                                        name="image"
                                        accept="image/*"
                                    />
                                    <p className="text-primary font-bold">
                                        <small>Supported format: jpg,png</small>
                                    </p>
                                    <div className="mt-2 mb-2">
                                        {
                                            state.attachment_image ? (
                                                <img
                                                    src={state.attachment_image}
                                                    alt="Image"
                                                    width="100"
                                                    height="100"
                                                    className="img-thumbnail"
                                                />
                                            ) : null
                                        }
                                    </div>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="danger" 
                            className="border-0 px-4 text-white"
                            onClick={() => setState((prevState) => ({...prevState, showPaymentForm: !state.showPaymentForm}))}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="primary" 
                            className="border-0 px-4"
                            onClick={payBeneficiary}
                        >
                            Submit <Spinner animation="border" size="sm" className={state.loading ? 'd-inline-block ms-2' : 'd-none'} />
                        </Button>
                    </Modal.Footer>
                </Modal>
                
                {/* Fund wallet */}
                <Modal 
                    show={state.showFundingForm}
                    onHide={() => setState((prevState) => ({...prevState, showFundingForm: !state.showFundingForm}))}
                    backdrop="static"
                >
                    <Modal.Header closeButton className="bg-primary p-1 px-2 text-white">
                        <Modal.Title>
                            Fund Wallet
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0">Amount</Form.Label>
                                    <AmountInput onChange={handleAmountUpdate} />
                                    {
                                        state.errors['amount'] && 
                                        <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} sm={12} xs={12} className="mb-3">
                                    <Form.Label className="mb-0">PIN</Form.Label>
                                    <Form.Control
                                        type="password"
                                        required
                                        placeholder="PIN"
                                        name="pin"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        autoComplete="off"
                                    />
                                    {
                                        state.errors['pin'] && 
                                        <Form.Text className="text-danger">{state.errors['pin']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group as={Col} md="12" className="mb-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <Form.Label className="mb-0">
                                        <span>OTP</span>  
                                        </Form.Label>
                                        <Button 
                                            type="button" 
                                            variant="outline-primary" 
                                            size="sm" 
                                            className="mb-1 w-25" 
                                            onClick={requestOTP}
                                        >Request OTP</Button> 
                                    </div>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="OTP"
                                        name="otp"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['otp'] && 
                                        <Form.Text className="text-danger">{state.errors['otp']}</Form.Text>
                                    }
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="danger" 
                            className="border-0 px-4 text-white"
                            onClick={() => setState((prevState) => ({...prevState, showFundingForm: !state.showFundingForm}))}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="primary" 
                            className="border-0 px-4"
                            onClick={fundWallet}
                        >
                            Submit <Spinner animation="border" size="sm" className={state.loading ? 'd-inline-block ms-2' : 'd-none'} />
                        </Button>
                    </Modal.Footer>
                </Modal>
                
                {/* Request Cash */}
                <Modal 
                    show={state.showRequestForm}
                    onHide={() => setState((prevState) => ({...prevState, showRequestForm: !state.showRequestForm}))}
                    backdrop="static"
                >
                    <Modal.Header closeButton className="bg-primary p-1 px-2 text-white">
                        <Modal.Title>
                            Request Petty Cash
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0">Amount</Form.Label>
                                    <AmountInput onChange={handleAmountUpdate} />
                                    {
                                        state.errors['amount'] && 
                                        <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} sm={12} xs={12} className="mb-3">
                                    <Form.Label className="mb-0">Reason</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Reason"
                                        name="reason"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        autoComplete="off"
                                    />
                                    {
                                        state.errors['reason'] && 
                                        <Form.Text className="text-danger">{state.errors['reason']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group as={Col} md={12} sm={12} className="mb-3">
                                    <span>Attach file</span><span className="text-danger">*</span>
                                    <Form.Control
                                        type="file"
                                        onChange={handleFileSelect}
                                        name="image"
                                        accept="image/*"
                                    />
                                    <p className="text-primary font-bold">
                                        <small>Supported format: jpg,png</small>
                                    </p>
                                    <div className="mt-2 mb-2">
                                        {
                                            state.attachment_image ? (
                                                <img
                                                    src={state.attachment_image}
                                                    alt="Image"
                                                    width="100"
                                                    height="100"
                                                    className="img-thumbnail"
                                                />
                                            ) : null
                                        }
                                    </div>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="danger" 
                            className="border-0 px-4 text-white"
                            onClick={() => setState((prevState) => ({...prevState, showRequestForm: !state.showRequestForm}))}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="primary" 
                            className="border-0 px-4"
                            onClick={submitPettyCashRequest}
                        >
                            Submit <Spinner animation="border" size="sm" className={state.loading ? 'd-inline-block ms-2' : 'd-none'} />
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Add Beneficiary */}
                <Modal 
                    show={state.showBeneficiaryForm}
                    onHide={() => setState((prevState) => ({...prevState, showBeneficiaryForm: !state.showBeneficiaryForm}))}
                    backdrop="static"
                >
                    <Modal.Header closeButton className="bg-primary p-1 px-2 text-white">
                        <Modal.Title>
                            Add Beneficiary
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0">Business Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Business Name"
                                        name="business_name"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        autoComplete="off"
                                    />
                                    {
                                        state.errors['business_name'] && 
                                        <Form.Text className="text-danger">{state.errors['business_name']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Bank Name</Form.Label>
                                    <Select 
                                        name="bank" 
                                        onChange={handleBankSelect} 
                                        options={state.banks}
                                        selected={state.payload.bank}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                height: "40px",
                                                backgroundColor: "#f2f2f2"
                                            }),
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0">Account Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Account Number"
                                        name="account_number"
                                        onChange={verifyAccountNumber}
                                        onKeyUp={handleValidation}
                                        maxLength={10}
                                        minLength={10}
                                        autoComplete="off"
                                    />
                                    {
                                        state.errors['account_number'] && 
                                        <Form.Text className="text-danger">{state.errors['account_number']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0">Account Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        readOnly
                                        placeholder="Account Name"
                                        name="account_name"
                                        defaultValue={state.payload.account_name}
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md={12} sm={12} xs={12} className="mb-3">
                                    <Form.Label className="mb-0">PIN</Form.Label>
                                    <Form.Control
                                        type="password"
                                        required
                                        placeholder="PIN"
                                        name="pin"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        autoComplete="off"
                                    />
                                    {
                                        state.errors['pin'] && 
                                        <Form.Text className="text-danger">{state.errors['pin']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group as={Col} md="12" className="mb-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <Form.Label className="mb-0">
                                        <span>OTP</span>  
                                        </Form.Label>
                                        <Button 
                                            type="button" 
                                            variant="outline-primary" 
                                            size="sm" 
                                            className="mb-1 w-25" 
                                            onClick={requestOTP}
                                        >Request OTP</Button> 
                                    </div>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="OTP"
                                        name="otp"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['otp'] && 
                                        <Form.Text className="text-danger">{state.errors['otp']}</Form.Text>
                                    }
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="danger" 
                            className="border-0 px-4 text-white"
                            onClick={() => setState((prevState) => ({...prevState, showBeneficiaryForm: !state.showBeneficiaryForm}))}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="primary" 
                            className="border-0 px-4"
                            onClick={confirmAction}
                        >
                            Add Beneficiary <Spinner animation="border" size="sm" className={state.loading ? 'd-inline-block ms-2' : 'd-none'} />
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Receipt */}
                <Modal 
                    show={state.showReceipt} 
                    fullscreen={true} 
                    onHide={() => setState((prevState) => ({...prevState, showReceipt: !state.showReceipt}))}
                    dialogClassName="receipt-screen-modal"
                    backdrop="static"
                    onClick={stopPropagation}
                >
                    <Modal.Header className="no-print">
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            <button className="btn-plain">
                                <FontAwesomeIcon icon="chevron-left" onClick={ () => setState((prevState) => ({...prevState, showReceipt: !state.showReceipt}))}/>
                            </button>
                            <div>
                                <Button type="button" className="btn-plain bg-primary me-2" onClick={ () => generatePdf() }>
                                    Download <FontAwesomeIcon icon="cloud-download"/>
                                </Button>
                                <Button type="button" className="btn-plain bg-primary me-2" onClick={ () => window.print() }>
                                    Print <FontAwesomeIcon icon="print"/>
                                </Button>
                                <Button type="button" className="btn-plain bg-primary" onClick={ () => handleShare() }>
                                    Share <FontAwesomeIcon icon="share"/>
                                </Button>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-2" >
                        <div className="invoice px-3 py-0 border border-0 printarea" id="pdf-content" ref={receiptRef}>
                            <div className="border-bottom border-bottom-1 d-flex align-items-center justify-content-between pb-2 py-2">
                                <Logo variant="dark"/>
                                <div>
                                    <h5 className="mb-0 text-right">Transaction Receipt</h5>
                                    <p className="text-muted text-sm m-0 text-right">Generated: {state.receipt.date !== null ? dateFormatter(state.receipt.date) : ''}</p>
                                </div>
                            </div>
                            <div className="table-responsive mb-3">
                                <table className="table border-0">
                                    <tbody>
                                        <tr>
                                            <td className="text-primary font-bold text-sm w-50 border-0">
                                                Transaction Amount
                                            </td>
                                            <td className="border-0 text-right">
                                                {formatCurrency(state.receipt.amount).with_currency}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-primary font-bold text-sm w-50 border-0">
                                                Fee
                                            </td>
                                            <td className="border-0 text-right">
                                                {formatCurrency(state.receipt.fee).with_currency}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-primary font-bold text-sm w-50 border-0">
                                                Settlement Amount
                                            </td>
                                            <td className="border-0 text-right">
                                                {formatCurrency(state.receipt.amount).with_currency}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-primary font-bold text-sm w-50 border-0">
                                                Date
                                            </td>
                                            <td className="border-0 text-right">
                                                {state.receipt.date !== null ? dateFormatter(state.receipt.date) : ''}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-primary font-bold text-sm w-50 border-0">
                                                Transaction ID
                                            </td>
                                            <td className="border-0 text-right">
                                                {state.receipt?.reference}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-primary font-bold text-sm w-50 border-0">
                                                Note
                                            </td>
                                            <td className="border-0 text-right">
                                                {state.receipt?.description}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-primary font-bold text-sm w-50 border-0">
                                                Status
                                            </td>
                                            <td className="border-0 text-right">
                                                {state.receipt?.status}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </Container>
        </Layout>
    );
}

export default PettyCash;